module["exports"] = [
  "#####",
  "#####-####"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/en/address/postcode.js
 ** module id = 289
 ** module chunks = 0
 **/